export default __webpack_public_path__ + "static/media/settings.577bee5f.svg";